import React from "react";

// Dashboard
const HRERPDashboard = React.lazy(() => import("../../HR/HRERPDashboard"));

// Attendance
const MainAttendanceCom = React.lazy(() => import("../../HR/attendence"));

// Employees
const MainAddEmployeeComp = React.lazy(() => import("../../HR/empolyees/addEmployee"));

// Salary
const MainSalaryCom = React.lazy(() => import("../../HR/empolyees/assignsalary"));

// Designation
const MainDesignationCom = React.lazy(() => import("../../HR/empolyees/designation"));

// Payroll - Advance
const PayAdvance = React.lazy(() =>
  import("../../HR/payroll/addadvance").then((m) => ({ default: m.PayAdvance })),
);
const PayAdvanceTable = React.lazy(() =>
  import("../../HR/payroll/addadvance").then((m) => ({
    default: m.PayAdvanceTable,
  })),
);

// Payroll - Loan
const PayLoan = React.lazy(() =>
  import("../../HR/payroll/addloan").then((m) => ({ default: m.PayLoan })),
);
const PayLoanTable = React.lazy(() =>
  import("../../HR/payroll/addloan").then((m) => ({ default: m.PayLoanTable })),
);

// Payroll - Pay Slip
const MainPaySlipCom = React.lazy(() => import("../../HR/payroll/payslip"));

export const hrRoutes = [
  {
    path: "/hr/dashboard",
    component: <HRERPDashboard />,
    rolename: "ERP-Human Resource_Dashboard",
  },

  // Attendance
  {
    path: "/hr/attendence",
    Component: MainAttendanceCom,
    props: { type: "AttendanceTable" },
    rolename: "Human Resource_Attendence",
  },
  {
    path: "/hr/attendence/generate",
    Component: MainAttendanceCom,
    props: { type: "GenerateAttendance" },
    rolename: "Human Resource_Attendence",
  },

  // Salary
  {
    path: "/hr/payroll/assignsalary",
    Component: MainSalaryCom,
    props: { type: "SalaryTable" },
    rolename: "Payroll_Assign Salary",
  },
  {
    path: "/hr/payroll/assignsalary/add",
    Component: MainSalaryCom,
    props: { type: "SalaryAdd" },
    rolename: "Payroll_Assign Salary",
  },

  // Advance/Loan
  {
    path: "/hr/payroll/advanceloan/advance-table",
    Component: PayAdvanceTable,
    rolename: "Advance/Loan_Advance",
  },
  {
    path: "/hr/payroll/advanceloan/advance-table/add",
    Component: PayAdvance,
    rolename: "Advance/Loan_Advance",
  },
  {
    path: "/hr/payroll/advanceloan/loan-table",
    Component: PayLoanTable,
    rolename: "Advance/Loan_Loan",
  },
  {
    path: "/hr/payroll/advanceloan/loan-table/add",
    Component: PayLoan,
    rolename: "Advance/Loan_Loan",
  },

  // Pay Slip
  {
    path: "/hr/payroll/payslip",
    Component: MainPaySlipCom,
    props: { type: "PaySlipTable" },
    rolename: "Payroll_Pay Slip",
  },
  {
    path: "/hr/payroll/payslip/generate-slip",
    Component: MainPaySlipCom,
    props: { type: "GenerateSlip" },
    rolename: "Payroll_Pay Slip",
  },
  {
    path: "/hr/payroll/payslip/Edit",
    Component: MainPaySlipCom,
    props: { type: "EditPaySlip" },
    rolename: "Payroll_Pay Slip",
  },

  // Employees
  {
    path: "/hr/employees/employee",
    Component: MainAddEmployeeComp,
    props: { type: "EmployeeTable" },
    rolename: "Employees_Employee",
  },
  {
    path: "/hr/employees/employee/add",
    Component: MainAddEmployeeComp,
    props: { type: "AddEmployee" },
    rolename: "Employees_Employee",
  },

  // Designation
  {
    path: "/hr/employees/designation",
    Component: MainDesignationCom,
    props: { type: "DesignationTable" },
    rolename: "Employees_Designation",
  },
  {
    path: "/hr/employees/designation/add",
    Component: MainDesignationCom,
    props: { type: "Designation" },
    rolename: "Employees_Designation",
  },
];
